import React, { useState, useEffect } from "react";
import { ModalXoa } from "./ChucNang/ModalXoa";
import { ThemMoiGoiVay } from "./ThemMoiGoiVay";
import { PopoversBootrap } from "../../../components/GenericComponent/PopoversBootrap";
import { formatNumber } from "utils/currencyFormat";
import { useSelector, useDispatch } from "react-redux";

export const ContentTable = ({ dataDanhSach, onSearch, phanQuyen }) => {
  const setModalEdit = (item) => {
    item.onSearch = onSearch;
    setDataFocus(item);
    handleShowEdit();
  };

  const dataSearch = useSelector((state) => state.dataSearchGoiVay);
  const [dataFocus, setDataFocus] = useState({});
  const [showEdit, setShowEdit] = useState(false);
  const handleCloseEdit = () => setShowEdit(false);
  const handleShowEdit = () => setShowEdit(true);
  const [isModalXoa, setModalXoa] = useState(false);
  const toggleModalXoa = () => {
    setModalXoa(!isModalXoa);
  };
  const deleteItem = (item) => {
    setDataFocus(item);
    toggleModalXoa();
  };
  // end lien kết ngân hàng
  return (
    <>
      {dataDanhSach.List.map((item, index) => (
        <div className="custom-table-row" key={item.Id}>
          <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile">
            <span className="mobile-column-name">STT</span>
            <div className="center-wrapper">
              <p className="text-center">
                {(dataSearch.iPageIndex - 1) * dataSearch.iPageSize + index + 1}
              </p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-20 flex-basis-20-sm  action-cell">
            <span className="mobile-column-name">Mã gói vay</span>
            <div className="center-wrapper">
              <p className="text-left">{item.MaGoiVay}</p>
            </div>
          </div>
          <div className="custom-table-cell flex-basis-30 flex-basis-30-sm  action-cell">
            <span className="mobile-column-name">Tên gói vay</span>
            <div className="center-wrapper">
              <p className="text-left">{item.TenGoiVay}</p>
            </div>
          </div>
          {phanQuyen.quytrinhpheduyet_danhsach == true && (
            <>
              <div className="custom-table-cell flex-basis-10 flex-basis-10-sm  action-cell">
                <span className="mobile-column-name">Loại gói vay</span>
                <div className="center-wrapper">
                  <p className="text-left">
                    {item.LoaiGoiVay === "TinChap" && <>Tín chấp</>}
                    {item.LoaiGoiVay === "TheChap" && <> Thế chấp</>}
                  </p>
                </div>
              </div>
            </>
          )}

          <div className="custom-table-cell flex-basis-20 flex-basis-20-sm  action-cell">
            <span className="mobile-column-name">Hạn mức gói vay </span>
            {phanQuyen.quytrinhpheduyet_danhsach == true && (
              <>
                <div className="center-wrapper">
                  <p className="text-left">
                    {formatNumber(item.HanMucGoiVay)}{" "}
                    {item.LoaiGoiVay === "TinChap" && <> VND</>}
                    {item.LoaiGoiVay === "TheChap" && <> %</>}
                  </p>
                  <p className="text-left">
                    (
                    {(item.LaiSuatKieu === "3" ||
                      item.LaiSuatKieu === "4" ||
                      item.LaiSuatKieu === "5" ||
                      item.LaiSuatKieu === "7") && <>{item.LaiSuat} %/</>}
                    {(item.LaiSuatKieu === "1" ||
                      item.LaiSuatKieu === "2" ||
                      item.LaiSuatKieu === "6") && (
                      <> {formatNumber(item.LaiSuat)} tr/</>
                    )}
                    {item.KyDongLaiLoai === "1" && <> {item.KyDongLai} ngày</>}
                    {item.KyDongLaiLoai === "4" && <> {item.KyDongLai} tuần</>}
                    {(item.KyDongLaiLoai === "3" ||
                      item.KyDongLaiLoai === "2") && (
                      <>{item.KyDongLai} tháng</>
                    )}
                    ){" "}
                  </p>

                  <p className="text-left">
                    (
                    {item.KyDongLaiLoai === "1" && (
                      <> {item.KyDongLai * item.SoLanTra} ngày</>
                    )}
                    {item.KyDongLaiLoai === "4" && (
                      <> {item.KyDongLai * item.SoLanTra} tuần</>
                    )}
                    {(item.KyDongLaiLoai === "3" ||
                      item.KyDongLaiLoai === "2") && (
                      <>{item.KyDongLai * item.SoLanTra} tháng</>
                    )}
                    )
                  </p>
                </div>
              </>
            )}
            {phanQuyen.quanlygoivay == true && (
              <>
                <div className="center-wrapper">
                  <p className="text-left">
                    {formatNumber(item.HanMucGoiVay)}{" "}
                  </p>
                </div>
              </>
            )}
          </div>
          <div className="custom-table-cell flex-basis-15 flex-basis-15-sm ">
            <span className="mobile-column-name">Thao Tac</span>
            <div
              className="center-wrapper text-center"
              style={{ fontSize: "20px" }}
            >
              {(phanQuyen.quanlygoivay == false ||
                phanQuyen.quanlygoivay_suagoivay) && (
                <>
                  <a
                    href={() => false}
                    onClick={(e) => setModalEdit(item)}
                    style={{ marginRight: "5px" }}
                  >
                    <PopoversBootrap
                      contentText="Sửa"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <img src="/app-assets/images/icon-edit-v2.png" />
                    </PopoversBootrap>
                  </a>
                </>
              )}
              {(phanQuyen.quanlygoivay == false ||
                phanQuyen.quanlygoivay_xoagoivay) && (
                <>
                  <a
                    href={() => false}
                    onClick={(e) => deleteItem(item)}
                    style={{ marginRight: "5px" }}
                  >
                    <PopoversBootrap
                      contentText="Xóa"
                      titleText=""
                      trigger={["hover", "focus"]}
                      placement={"top"}
                    >
                      <img
                        style={{ marginLeft: "5px" }}
                        src="/app-assets/images/icon-xoa-v2.png"
                      />
                    </PopoversBootrap>
                  </a>
                </>
              )}
            </div>
          </div>
        </div>
      ))}
      {showEdit && (
        <ThemMoiGoiVay
          data={dataFocus}
          show={showEdit}
          onHide={handleCloseEdit}
        />
      )}
      <ModalXoa
        isModalVisible={isModalXoa}
        onSearch={onSearch}
        toggleModal={toggleModalXoa}
        item={dataFocus}
      />
    </>
  );
};
